import { object, string } from 'zod';

import { IS_REQUIRED, isStringLengthUpTo } from '@occc-app/lib/constants/validationMessages';
import { makeZodValidate } from '@occc/ui-forms';
import { EngagementChannelConfigSchema } from '@occc/ui-notifications';

export const MessageNameAndDescriptionSchema = object({
  title: string({ required_error: IS_REQUIRED })
    .trim()
    .min(1, IS_REQUIRED)
    .max(255, isStringLengthUpTo(255)),
  description: string().trim().optional(),
});

export const MessagingCampaignConfigureFormSchema = MessageNameAndDescriptionSchema.and(
  EngagementChannelConfigSchema,
);
export const validateConfigureForm = makeZodValidate(MessagingCampaignConfigureFormSchema);
